import React from 'react'
import ReactDOM from 'react-dom'
import App from './ui/App'

ReactDOM.render(
    <App />,
    document.getElementById('app')!
)
